import { API } from 'store/middleware/api';

export const VEHICLE = {
	VEHICLE_LENGTH_REQUEST: 'SFDC/SEARCH/VEHICLE_LENGTH_REQUEST',
	VEHICLE_LENGTH_SUCCESS: 'SFDC/SEARCH/VEHICLE_LENGTH_SUCCESS',
	VEHICLE_LENGTH_FAILURE: 'SFDC/SEARCH/VEHICLE_LENGTH_FAILURE'
};

export function getVehicleLengthMakes(query) {
	return {
		[API]: {
			types: [VEHICLE.VEHICLE_LENGTH_REQUEST, VEHICLE.VEHICLE_LENGTH_SUCCESS, VEHICLE.VEHICLE_LENGTH_FAILURE],
			endpoint: '/vehicle-length-tool/get-makes',
			query
		}
	};
}

export function getVehicleLengthModels(query) {
	return {
		[API]: {
			types: [VEHICLE.VEHICLE_LENGTH_REQUEST, VEHICLE.VEHICLE_LENGTH_SUCCESS, VEHICLE.VEHICLE_LENGTH_FAILURE],
			endpoint: '/vehicle-length-tool/get-models',
			query
		}
	};
}

export function getVehicleLengthModelInfo(query) {
	return {
		[API]: {
			types: [VEHICLE.VEHICLE_LENGTH_REQUEST, VEHICLE.VEHICLE_LENGTH_SUCCESS, VEHICLE.VEHICLE_LENGTH_FAILURE],
			endpoint: '/vehicle-length-tool/get-model-info',
			query
		}
	};
}
